export default "__VITE_ASSET__CKwghG8k__";